<template>
	<p v-if="url" class="privacy-notice">
		{{ texts.before }}
		<a :href="url" target="_blank" rel="noopener">{{ texts.link }}</a>{{ texts.after }}
		{{ texts.note }}
	</p>
</template>

<script setup lang="ts">
import {computed} from "vue";
import Cookie from "js-cookie";
import {useSiteCheckStore} from "../../Stores/SiteCheck/SiteCheck";

/**
 * The link of the privacy notice next to a form. It is only information: not a checkbox, and it has nothing to do
 * with a marketing subscription (a request or a message can be sent without any marketing consent).
 */
const url = computed(() => useSiteCheckStore().currentSite?.privacyUrl ?? '');

const texts = computed(() => (Cookie.get('lang') ?? 'hu') === 'hu'
	? {
		before: 'Az adataid kezeléséről az',
		link: 'Adatkezelési tájékoztatóban',
		after: ' olvashatsz.',
		note: 'Az üzenet elküldéséhez nem kell marketing-hozzájárulást adnod.',
	}
	: {
		before: 'You can read how we handle your data in the',
		link: 'Privacy notice',
		after: '.',
		note: 'You do not need to give marketing consent to send your message.',
	});
</script>
